// @flow
import React from 'react'
import classNames from 'classnames'

import AbstractFormField from './AbstractFormField'
import { FieldLabel } from '../../../Components'

import type { DefaultFormFieldState } from './AbstractFormField'
import type { ValidationErrorType } from '../../Types/ValidationError'

type Props = {
  domain: { _type: string, },
  enabled?: boolean,
  id: string,
  isPristine?: boolean,
  label: string,
  name: string,
  negationLabel: string,
  onBlur?: Function,
  onChange: (value: boolean) => void,
  prefix: string,
  textMode?: boolean,
  validationErrors: ValidationErrorType,
  value: boolean,
}

/**
 * Component for rendering checkbox
 * @example ./docs/BoolNegation.md
 */
export default class BoolNegation extends AbstractFormField<Props, DefaultFormFieldState> {
  static defaultProps = {
    enabled: true,
    isPristine: false,
    textMode: false,
  }

  handleOnChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    if (this.props.enabled) {
      this.props.onChange(!event.target.checked)
    }
  }

  handleOnBlur = (event: SyntheticInputEvent<HTMLInputElement>) => {
    if (this.props.onBlur && event && event.target) {
      this.props.onBlur(`${this.props.prefix}${this.props.name}`, !event.target.checked, [], true)
    }
    this.setState({ pristine: false })
  }

  render() {
    if (this.props.textMode) {
      return !this.props.value
        ? <span>{this.props.negationLabel}</span>
        : null
    }

    const classes = ['custom-control-input']
    if (this.hasErrors() && !this.isPristine()) {
      classes.push('is-invalid')
    }

    return (
      <div className='custom-control custom-checkbox'>
        <input
          checked={!this.props.value}
          className={classNames(classes)}
          data-hj-whitelist
          id={this.props.id}
          name={this.props.name}
          onBlur={this.handleOnBlur}
          onChange={this.handleOnChange}
          readOnly={!this.props.enabled}
          type='checkbox'
        />
        {this.props.negationLabel && <FieldLabel
          className='custom-control-label'
          id={this.props.id}
          label={this.props.negationLabel}
        />}
        {this.renderError()}
      </div>
    )
  }
}
